jQuery(document).ready(function($) {  
  // any code js
  
  // $('.selectSizeBtn').on('click', function(e){
  $(document).on('click','.selectSizeBtn', function(e){
    // alert('hide');
    $('.selectSizeErrorMsg').removeClass('hide');
    e.preventDefault();
    return false;
    
  });
  // $('.nt-swatch').on('click', function(){
  // $(document).on('click','.nt-swatch', function(){
  //   alert('show');
  //   $('.selectSizeErrorMsg').addClass('hide');
  //   $('.selectSizeBtn').addClass('hide');
  //   $('.afterSelectSize').removeClass('hide');
  // });
});


function selectSizeOptionTrue(){
  // alert('show');
    $('.selectSizeErrorMsg').addClass('hide');
    $('.selectSizeBtn').addClass('hide');
    $('.afterSelectSize').removeClass('hide');
}


// var settings = {
//   "url": "https://urbanstree.myshopify.com/admin/api/2024-07/products/6884330831985.json",
//   "method": "GET",
//   "crossDomain": true,
//   "headers": {
//     "X-Shopify-Access-Token": "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"
//   },
//   "contentType": "application/json"
// };

// $.ajax(settings).done(function (response) {
//   console.log(response);
// });
